import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, UserRound } from "lucide-react";
import { toast } from "sonner";
import { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const inp = "w-full rounded-xl border border-amber-900/20 bg-white px-4 py-2.5 text-sm outline-none focus:border-amber-deep";

export default function CartAccountGate() {
  const { user, login, register } = useAuth();
  const [mode, setMode] = useState("register");
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const up = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));

  if (user && user.role !== "customer") {
    return <p data-testid="cart-account-wrong-role" className="rounded-xl bg-terra/10 px-4 py-3 text-sm text-bark">Vous êtes connecté avec un compte administrateur ou école. Pour commander, déconnectez-vous puis utilisez un compte client.</p>;
  }

  const submit = async (e) => {
    e.preventDefault();
    if (mode === "register" && f.name.trim().length < 2) return toast.error("Indiquez votre nom");
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(f.email.trim())) return toast.error("L'adresse e-mail est obligatoire");
    if (f.password.length < 8) return toast.error("Le mot de passe doit contenir au moins 8 caractères");
    setBusy(true);
    try {
      if (mode === "register") {
        await register(f.name.trim(), f.email.trim(), f.password);
        toast.success("Votre compte est créé, vous pouvez finaliser votre commande");
      } else {
        const data = await login(f.email.trim(), f.password);
        if (data?.requires_2fa) toast.error("Ce compte utilise la double authentification : connectez-vous depuis la page Mon compte");
      }
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Connexion impossible");
    } finally {
      setBusy(false);
    }
  };

  const tab = (id, label) => (
    <button type="button" data-testid={`cart-account-tab-${id}`} onClick={() => setMode(id)} className={`flex-1 rounded-full px-3 py-1.5 text-xs font-semibold transition-colors ${mode === id ? "bg-amber-deep text-white" : "text-bark-soft hover:text-amber-deep"}`}>{label}</button>
  );

  return (
    <form data-testid="cart-account-gate" onSubmit={submit} className="space-y-3 rounded-2xl border-2 border-amber-deep/40 bg-amber-50/70 p-4">
      <p className="flex items-center gap-2 text-sm font-semibold text-bark"><UserRound size={16} className="text-amber-deep" /> Un compte client est nécessaire pour commander</p>
      <p className="text-xs text-bark-soft">Votre panier est conservé. Suivi de commande, points fidélité et avantages membres inclus.</p>
      <div className="flex rounded-full border border-amber-900/15 bg-white p-0.5">{tab("register", "Créer mon compte")}{tab("login", "J'ai déjà un compte")}</div>
      {mode === "register" && <input data-testid="cart-account-name" autoComplete="name" value={f.name} onChange={up("name")} placeholder="Nom et prénom *" className={inp} />}
      <input data-testid="cart-account-email" type="email" required autoComplete="email" value={f.email} onChange={up("email")} placeholder="E-mail *" className={inp} />
      <input data-testid="cart-account-password" type="password" autoComplete={mode === "register" ? "new-password" : "current-password"} value={f.password} onChange={up("password")} placeholder={mode === "register" ? "Mot de passe (8 caractères min.) *" : "Mot de passe *"} className={inp} />
      <button data-testid="cart-account-submit" disabled={busy} className="flex w-full items-center justify-center gap-2 rounded-full bg-amber-deep py-2.5 text-sm font-semibold text-white transition-colors hover:bg-honey disabled:opacity-60">
        {busy && <Loader2 size={15} className="animate-spin" />} {mode === "register" ? "Créer mon compte et continuer" : "Me connecter et continuer"}
      </button>
      {mode === "login" && <Link to="/compte/connexion" data-testid="cart-account-forgot" className="block text-center text-xs text-amber-deep underline underline-offset-2">Mot de passe oublié ?</Link>}
    </form>
  );
}
